"use client";

import React from "react";
import { ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  num: "01",
  title: "Geist & Psyche",
  desc: "Innere Klarheit und psychologische Resilienz bilden das Fundament für persönliches Wachstum und gesunde Führung."
}, {
  num: "02",
  title: "Körper & Bewegung",
  desc: "Durch Tai Chi und bewusste Körperarbeit stärken wir die physische Basis für Belastbarkeit und Vitalität."
}, {
  num: "03",
  title: "Natur & Erdung",
  desc: "Die Wildnis des Soonwalds dient als Kraftort und Lehrmeisterin für ursprüngliche Verbundenheit und Fokus."
}, {
  num: "04",
  title: "Struktur & Ordnung",
  desc: "Klare organisatorische Rahmenbedingungen schaffen den Raum, in dem sich Potenzial sicher entfalten kann."
}];
export default function WhyAutoMoti() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}